<div class="error-container">
    <div class="error-size">404</div>
    <div class="msg-size">NOT FOUND</div>
    <p>The webpage might be temporarily down or it may have moved permanently to a new web address.</p>
</div>